/* One query policy for full search and autocomplete. Shopify indexes new titles automatically. */
(function (root) {
  'use strict';
  const groups = [
    ['standing desk', 'standing desks', 'height adjustable desk', 'height adjustable desks', 'adjustable desk', 'adjustable desks', 'sit stand desk', 'sit stand desks', 'sit to stand desk', 'electric desk'],
    ['standing table', 'height adjustable table', 'adjustable table', 'standing desk', 'height adjustable desk'],
    ['sofa bed', 'sofa beds', 'sleeper sofa', 'sleeper sofas', 'bed settee'],
    ['bedside table', 'bedside tables', 'nightstand', 'nightstands', 'bedside cabinet'],
    ['tv stand', 'tv stands', 'tv unit', 'tv units', 'tv console', 'television stand', 'media console'],
    ['chest of drawers', 'drawer chest', 'drawer unit'],
    ['dining set', 'dining sets', 'dining table'],
    ['coffee table', 'coffee tables', 'center table', 'centre table'],
    ['side table', 'side tables', 'end table', 'end tables'],
    ['bookcase', 'bookcases', 'bookshelf', 'bookshelves'],
    ['sofa', 'sofas', 'couch', 'couches', 'settee', 'settees'],
    ['shelf', 'shelves', 'shelving'],
    ['wardrobe', 'wardrobes', 'armoire', 'armoires'],
    ['cupboard', 'cupboards', 'cabinet', 'cabinets'],
    ['armchair', 'armchairs', 'accent chair', 'accent chairs'],
    ['desk', 'desks'], ['bed', 'beds'], ['chair', 'chairs'], ['table', 'tables'],
    ['dresser', 'dressers'], ['mirror', 'mirrors'], ['ottoman', 'ottomans', 'footstool', 'footstools'],
    ['home center', 'home centre'], ['grey', 'gray'], ['center', 'centre'], ['2 seater', 'two seater'], ['3 seater', 'three seater']
  ];
  const corrections = {deskk:'desk',dsek:'desk',sofaa:'sofa',cofee:'coffee',coffe:'coffee',wardobe:'wardrobe',wardrob:'wardrobe',shelfs:'shelves',dinng:'dining'};
  const stopWords = new Set(['a','an','the','for','of','and','with','in','at','to']);
  const normalize = value => String(value || '').normalize('NFKC').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim().replace(/\s+/g, ' ');
  const aliases = new Map();
  for (const group of groups) for (const term of group) if (!aliases.has(term)) aliases.set(term, group);
  const phrases = [...aliases.keys()].sort((a,b) => b.split(' ').length - a.split(' ').length);
  const positiveQuery = value => value.replace(/ AND -product_type:"Beds"$/, '');
  const isCompiled = value => /^\(title:"[^"()]+"(?: OR title:"[^"()]+")*\)(?: AND \(title:"[^"()]+"(?: OR title:"[^"()]+")*\))*$/.test(positiveQuery(value));
  function display(value) {
    if (!isCompiled(value)) return value || '';
    return positiveQuery(value).split(' AND ').map(clause => clause.match(/^\(title:"([^"]+)"/)[1]).join(' ');
  }
  function compile(value) {
    if (isCompiled(value)) return value;
    const normalized = normalize(value);
    if (!normalized) return '';
    const words = normalized.split(' '), clauses = [];
    for (let i=0; i<words.length;) {
      const rest = words.slice(i).join(' ');
      const correctedRest = words.slice(i).map(word => corrections[word] || word).join(' ');
      const phrase = phrases.find(term => correctedRest === term || correctedRest.startsWith(term + ' '));
      const partial = !phrase && rest.length >= 3 ? phrases.find(term => term.startsWith(rest)) : null;
      let original = phrase ? words.slice(i, i + phrase.split(' ').length).join(' ') : (partial ? rest : words[i]);
      i += original.split(' ').length;
      if (stopWords.has(original)) continue;
      const corrected = phrase || partial || corrections[original] || original;
      // Match features and object independently: future titles can say
      // "Height Adjustable Office Desk" without needing a per-product synonym.
      if (aliases.get(corrected) === groups[0] && original.includes(' ')) {
        const parts = original.split(' ');
        const object = parts.pop();
        const features = [...new Set([parts.join(' '), 'standing', 'height adjustable', 'adjustable', 'sit stand', 'sit to stand', 'electric'])];
        clauses.push('(' + features.map(term => 'title:"' + term + '"').join(' OR ') + ')');
        clauses.push('(' + [...new Set([object, 'desk', 'desks'])].map(term => 'title:"' + term + '"').join(' OR ') + ')');
        continue;
      }
      const alternatives = [...new Set([original, ...(aliases.get(corrected) || [corrected])])];
      clauses.push('(' + alternatives.map(term => 'title:"' + term + '"').join(' OR ') + ')');
    }
    // A punctuation-only/stopword-only search must never turn into an all-products query.
    let query = clauses.length ? clauses.join(' AND ') : '(title:"' + normalized + '")';
    if (/\b(desks?|shelf|shelves|shelving|nightstands?|bedside|wardrobes?|cupboards?|cabinets?|bookcases?|bookshelf|bookshelves|dressers?|tables?|chairs?)\b/.test(query) && !/\b(beds?|bedroom|bunk|loft)\b/.test(normalized)) query += ' AND -product_type:"Beds"';
    return query;
  }
  root.DukaanSearch = {compile, display, isCompiled};
  if (typeof module !== 'undefined') module.exports = root.DukaanSearch;
  if (typeof document === 'undefined') return;
  const isSearch = url => /\/search\/?$/.test(url.pathname) && url.origin === location.origin;
  function searchURL(url, term) {
    url.searchParams.set('q', compile(term));
    url.searchParams.set('type','product');
    url.searchParams.delete('resources[type]');
    return url;
  }
  const current = new URL(location.href);
  if (isSearch(current) && current.searchParams.get('q') && !current.searchParams.has('view') && !current.searchParams.has('section_id')) {
    const q = current.searchParams.get('q');
    const query = compile(q);
    if (query && (query !== q || current.searchParams.get('type') !== 'product')) {
      location.replace(searchURL(current, q).href);
      return;
    }
  }
  // Bubble after the theme's keyboard-selection handler, which may cancel a submit.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || event.defaultPrevented) return;
    const url = new URL(form.action, location.href);
    const input = form.querySelector('input[name="q"]:not([type="hidden"])');
    if (!isSearch(url) || !input) return;
    event.preventDefault();
    if (!normalize(input.value)) return;
    url.search = new URLSearchParams(new FormData(form)).toString();
    url.searchParams.delete('page');
    location.assign(searchURL(url, input.value).href);
  });
  // Includes trending links, no-result links, and links added by theme sections later.
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (isSearch(url) && url.searchParams.get('q') && !url.searchParams.has('view')) link.href = searchURL(url, url.searchParams.get('q')).href;
  }, true);
})(typeof window === 'undefined' ? globalThis : window);
